module.exports = __webpack_public_path__ + "img/shop-icon.4c272e98.svg";